module.exports = __webpack_public_path__ + "img/brand-egeniq.b91d8fc7.svg";